import EmailConfirmPage from './components/EmailConfirmPage';

export default EmailConfirmPage;
